<template>
  <PrimeToast />
  <component
    :is="layout"
    v-if="routeReady"
    v-bind="route.meta?.background ? { background: route.meta.background } : {}"
    :style="route.meta?.styles"
  >
    <RouterView />
  </component>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useLanguageStore } from '@/store/language.js'
import { useI18n } from 'vue-i18n'
import PrimeToast from '@/components/toast/PrimeToast.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import ErrorLayout from '@/layouts/ErrorLayout.vue'
import { useRoute, useRouter } from 'vue-router'
import { useThemeStore } from '@/store/theme.js'
import { storeToRefs } from 'pinia'
import { setCoreTheme } from '@/plugins/theme.js'
import EmptyLayout from '@/layouts/EmptyLayout.vue'

const themeStore = useThemeStore()
const { theme } = storeToRefs(themeStore)

const route = useRoute()
const router = useRouter()

const languageStore = useLanguageStore()
const { locale } = useI18n()
const routeReady = ref(false)

const layouts = {
  default: DefaultLayout,
  auth: AuthLayout,
  error: ErrorLayout,
  empty: EmptyLayout
}

const layout = computed(() => {
  const name = route.meta?.layout || 'default'

  return layouts[name]
})

watch(
  () => languageStore.currentLocale,
  (newLocale) => {
    locale.value = newLocale
  },
  { immediate: true }
)

watch(theme, (theme) => {
  if (theme) {
    setCoreTheme(theme)
  }
})

onMounted(async () => {
  await router.isReady()
  routeReady.value = true
  setCoreTheme(theme.value)
})
</script>
